import React from 'react';
import ZoomIcon from '../assets/icons/ZoomIcon.svg';
import NoZoomIcon from '../assets/icons/NoZoomIcon.svg';

/* Botón flotante que activa/desactiva la lupa de ZoomableDiv.
   Estilos, hover y posición (esquina superior derecha del .square-item,
   su ancestro posicionado) viven en .zoom-icon (App.css). */
const ZoomToggle = ({ isZoomEnabled, onToggle }) => (
  <img
    src={isZoomEnabled ? NoZoomIcon : ZoomIcon}
    alt="Toggle Zoom"
    className={`zoom-icon ${isZoomEnabled ? 'zoom-on' : ''}`}
    onClick={onToggle}
  />
);

export default ZoomToggle;
